export enum AppEnvironment {
    LOCAL = 'local',
    STAGING = 'staging',
    DEVELOPMENT = 'development',
    PRODUCTION = 'production',
    // Set by the e2e build (REACT_APP_AXLE_ENV=test in .github/workflows/e2e.yml).
    TEST = 'test',
}
